export default __webpack_public_path__ + "static/media/researchAT.71a73472.png";